export enum PaymentListTabsEnum {
  DRAFT = 'draft',
  BOOKED = 'booked',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  PENDING  = 'pending',
  TEMPLATE = 'template',
  ALL = 'all',
}
